import styled from 'styled-components';

export const FormSectionWrapper = styled.section<{
  answered?: boolean;
  isSubmit?: boolean;
  questionsMaxHeight?: number;
}>`
  width: 100%;
  height: max-content;
  display: flex;
  position: relative;

  div.vertical-line {
    width: 2px;
    align-self: stretch;
    background-color: #e2e2e2;

    @media (max-width: 600px) {
      margin-left: 4px;
    }
  }

  .cards-container {
    display: flex;
    flex-direction: column;
    padding-left: 38px;
    width: 100%;

    @media (max-width: 600px) {
      padding-left: 22px;
    }

    .section-container {
      position: relative;
    }

    .questions-container {
      display: flex;
      flex-direction: column;
      gap: 14px;
      opacity: 1;
      max-height: 5000px;
      transition:
        max-height 0.4s ease-out,
        opacity 0.4s ease-out;
      padding-bottom: 20px;
      overflow: hidden;

      &.hide {
        max-height: 0;
        opacity: 0;
      }
    }
  }

  .circle {
    position: absolute;
    top: calc(50% - 10px);
    left: -38px;
    width: 36px;
    height: 36px;
    border-radius: 100%;
    border: 2px solid ${(props) => (props.answered ? '#66B44E' : '#e2e2e2')};
    transform: translate(-50%, -50%);
    background-color: ${(props) =>
      props.answered ? '#66B44E' : props.isSubmit ? '#e2e2e2' : props.theme.colors.background};
    display: flex;
    align-items: center;
    justify-content: center;

    &.submit {
      left: 0;
    }

    @media (max-width: 600px) {
      left: -22px;
      width: 24px;
      height: 24px;

      &.submit {
        left: 5px;
      }
    }

    svg {
      color: #d1ffc3;
    }

    &.error {
      background-color: red !important;
      border: 2px solid red !important;
      color: ${(props) => props.theme.colors.background};
      font-size: 26px;
    }
  }

  .submit-button {
    width: 100%;
    max-width: 1000px;
    height: 50px;
    margin-left: ${(props) => (props.isSubmit ? '38px' : '0')};
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.colors.blue};
    color: white;
    font-size: 20px;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    transition: all 0.2s;

    @media (max-width: 600px) {
      width: 100%;
      margin-left: 0;
      height: 60px;
      font-size: 18px;
    }

    &:not(:focus-visible) {
      outline: none;
    }

    &:focus-visible {
      outline: 3px solid ${(props) => props.theme.colors.blue};
      outline-offset: 2px;
    }

    &:hover:not(:disabled) {
      background-color: ${(props) => props.theme.colors.darkBlue};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .lds-ring {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 26px;
      height: 26px;
    }

    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 26px;
      height: 26px;
      margin: 8px;
      border: 4px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }

    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }

    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }

    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }

    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 16px;

  svg {
    font-size: 32px;
    color: ${(props) => props.theme.colors.blue};
  }

  p {
    font-size: 16px;
    color: ${(props) => props.theme.colors.authorText};
    text-align: center;
    margin: 0;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 16px;
  padding: 24px;
  background-color: #fee2e2;
  border-radius: 10px;
  border: 1px solid #fca5a5;

  svg {
    font-size: 32px;
    color: #dc2626;
  }

  p {
    font-size: 16px;
    color: #991b1b;
    text-align: center;
    margin: 0;
  }

  button {
    margin-top: 8px;
    padding: 10px 24px;
    background-color: #dc2626;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #b91c1c;
    }

    &:focus-visible {
      outline: 2px solid #dc2626;
      outline-offset: 2px;
    }
  }
`;

export const SectionCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #e8f5fa;
  opacity: 0.85;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 14px;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.blue};
    margin: 0;
    margin-bottom: 2px;
  }

  p {
    font-size: 16px;
    color: #175974;
    margin: 0;
  }

  svg {
    color: ${(props) => props.theme.colors.darkText};
  }
`;
